import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import CookieLink from '../../../ui/CookieLink';

const IS_HOLIDAY = process.env.REACT_APP_SHOP_ISHOLIDAY === 'true';
const REACT_APP_SILVEROAK_LINK = `${process.env.REACT_APP_SILVEROAK_LINK}`;
const getCompare = value => (value || '').split('/').filter(v => !!v).pop();

const ShopBy = ({ location }) => {
  const { pathname } = location || {};
  const compare = getCompare(pathname);
  const activeMenuItem = value =>
    compare === getCompare(value) ? 'selected' : '';
  return (
    <div>
      <h3 className="column-header grid-header">Shop By</h3>
      <div className="d-block d-md-none mobile-filters">
        <Link to="/shop/wines/" className={activeMenuItem('/wines')}>
          All Wines
        </Link>
        <Link to="/shop/pinot-noir/" className={activeMenuItem('/pinot-noir')}>
          Pinot Noir
        </Link>
        <Link
          to="/shop/sauvignon-blanc/"
          className={activeMenuItem('/sauvignon-blanc')}
        >
          Sauvignon Blanc
        </Link>
        <Link to="/shop/ava-wines/" className={activeMenuItem('/ava-wines')}>
          AVA Wines
        </Link>
        <Link
          to="/shop/single-vineyard-wines/"
          className={activeMenuItem('/single-vineyard-wines')}
        >
          Single Vineyard Wines
        </Link>
        <Link
          to="/shop/exclusive-offers/"
          className={activeMenuItem('/special-offers')}
        >
          Exclusive Offers
        </Link>
        {IS_HOLIDAY && <Link
          to="/shop/holiday-offers/"
          className={activeMenuItem('/special-offers')}
        >
          Holiday Offers
        </Link>}
        {/* <Link to="/merchandise" className={activeMenuItem('/merchandise')}>
          Merchandise
        </Link> */}
        <Link to="/shop/events/" className={activeMenuItem('/events')}>
          Events
        </Link>
        <CookieLink
          href={`${REACT_APP_SILVEROAK_LINK}/shop/`}
          label="Shop Silver Oak"
        />
        <Link to="/shop/" className={activeMenuItem('/shop')}>
          All Products
        </Link>
      </div>
      <div className="d-none d-md-block d-lg-block d-xl-block">
        <div className="grid-filters">
          <h4>Varietal</h4>
          <Link
            to="/shop/pinot-noir/"
            className={activeMenuItem('/pinot-noir')}
          >
            Pinot Noir
          </Link>
          <Link
            to="/shop/sauvignon-blanc/"
            className={activeMenuItem('/sauvignon-blanc')}
          >
            Sauvignon Blanc
          </Link>
          <Link to="/shop/wines/" className={activeMenuItem('/wines')}>
            All Varietals
          </Link>
        </div>
        <div className="grid-filters">
          <h4>Category</h4>
          <Link to="/shop/ava-wines/" className={activeMenuItem('/ava-wines')}>
            AVA Wines
          </Link>
          <Link
            to="/shop/single-vineyard-wines/"
            className={activeMenuItem('/single-vineyard-wines')}
          >
            Single Vineyard Wines
          </Link>
         <Link
            to="/shop/exclusive-offers/"
            className={activeMenuItem('/special-offers')}
          >
            Exclusive Offers
          </Link>
          {IS_HOLIDAY && <Link
            to="/shop/holiday-offers/"
            className={activeMenuItem('/special-offers')}
          >
            Holiday Offers
          </Link>}
          {/* <Link to="/shop/merchandise" className={activeMenuItem('/merchandise')}>
            Merchandise
          </Link> */}
          <Link to="/shop/events/" className={activeMenuItem('/events')}>
            Events
          </Link>
          <CookieLink
            href={`${REACT_APP_SILVEROAK_LINK}/shop/`}
            label="Shop Silver Oak"
          />
        </div>
        <div className="grid-filters">
          <Link to="/shop/" className={activeMenuItem('/shop')}>
            All Products
          </Link>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ShopBy);
